import type { NextPage } from 'next'
import { ErrorPageWithRetryDynamic } from './components/ErrorPageWithRetry/ErrorPageWithRetryDynamic'
import type { WithPageErrorRecoveryProps } from './withPageErrorRecovery.types'

/**
 * HOC that wraps a page component with page error recovery and automatic retry.
 * If error prop is present, renders ErrorPage with integrated retry logic.
 * Used on every page to handle server-side errors gracefully with automatic recovery.
 */
export const withPageErrorRecovery = <P extends object = object>(PageComponent: NextPage<P>) => {
  const WrappedComponent: NextPage<WithPageErrorRecoveryProps<P>> = (props) =>
    'error' in props ? <ErrorPageWithRetryDynamic {...props.error} /> : <PageComponent {...props} />

  WrappedComponent.displayName = `withPageErrorRecovery(${PageComponent.displayName || PageComponent.name})`

  return WrappedComponent
}
